$(".accordion--title-link").on("click", function (e) {
  e.preventDefault();

  var target = $($(this).attr("href"));
  target.toggleClass("is-collapsed");

  if (target.hasClass("is-collapsed")) {
    $(this).attr("aria-expanded", "false");
  } else {
    $(this).attr("aria-expanded", "true");
  }
});
